import React from "react";
import Navigation from "../components/Navigation";
import Zoom from "react-reveal";
import { Link } from "react-router-dom";
import GithubIcon from "../assets/icons/github.svg";
import Slide from "react-reveal/Slide";

export default function About() {
	return (
		<>
			<Navigation />
			<Zoom>
				<section className="container mx-auto p-5">
					<div className="flex justify-between items-center">
						<h1 className="text-2xl ml-3">Projects And Open Source</h1>
						<Link className="text-lg font-medium ml-3 hover:underline" to="/">
							View All Source
						</Link>
					</div>
					<hr className="w-1/6 ml-3" />
					<div className=" shadow-md  h-full bg-secondColors-primary rounded-xl p-4  mt-8 ">
						<div className="flex flex-wrap px-6">
							<Slide left index={100}>
								<div className="w-full lg:w-1/3   md:px-4 lg:px-6 py-5 rounded-xl">
									<div className="bg-white rounded-lg">
										<div>
											<img
												src="https://images.pexels.com/photos/956999/milky-way-starry-sky-night-sky-star-956999.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
												alt=""
												className="h-56 w-full border-white border-8 rounded-lg"
											/>
										</div>
										<div className="px-4 py-4 md:px-10">
											<h1 className="font-bold text-lg text-center text-black">
												StayCation
											</h1>
											<p className="py-4 text-black text-left">
												Lorem ipsum dolor sit amet consectetur adipisicing elit.
												Excepturi quas sapiente voluptate earum natus facilis
												dolor deserunt dolorum tempora obcaecati consequatur
												rem, vel distinctio perferendis tempore nemo sequi eos
												accusantium.
											</p>
										</div>
									</div>

									<Link className="flex justify-center mt-3" to="/">
										<img
											src={GithubIcon}
											style={{ width: "30px", height: "30px" }}
											alt=""
										/>
										<p className="mt-1 ml-2 font-medium">View Code</p>
									</Link>
								</div>
							</Slide>
							<Slide bottom index={250}>
								<div className="w-full lg:w-1/3   md:px-4 lg:px-6 py-5 rounded-xl">
									<div className="bg-white rounded-lg">
										<div>
											<img
												src="https://images.pexels.com/photos/956999/milky-way-starry-sky-night-sky-star-956999.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
												alt=""
												className="h-56 w-full border-white border-8 rounded-lg"
											/>
										</div>
										<div className="px-4 py-4 md:px-10">
											<h1 className="font-bold text-lg text-center text-black">
												StayCation
											</h1>
											<p className="py-4 text-black text-left">
												Lorem ipsum dolor sit amet consectetur adipisicing elit.
												Excepturi quas sapiente voluptate earum natus facilis
												dolor deserunt dolorum tempora obcaecati consequatur
												rem, vel distinctio perferendis tempore nemo sequi eos
												accusantium.
											</p>
										</div>
									</div>
									<Link className="flex justify-center mt-3" to="/">
										<img
											src={GithubIcon}
											style={{ width: "30px", height: "30px" }}
											alt=""
										/>
										<p className="mt-1 ml-2 font-medium">View Code</p>
									</Link>
								</div>
							</Slide>
							<Slide right index={350}>
								<div className="w-full lg:w-1/3   md:px-4 lg:px-6 py-5 rounded-xl">
									<div className="bg-white rounded-lg">
										<div>
											<img
												src="https://images.pexels.com/photos/956999/milky-way-starry-sky-night-sky-star-956999.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
												alt=""
												className="h-56 w-full border-white border-8 rounded-lg"
											/>
										</div>
										<div className="px-4 py-4 md:px-10">
											<h1 className="font-bold text-lg text-center text-black">
												StayCation
											</h1>
											<p className="py-4 text-black text-left">
												Lorem ipsum dolor sit amet consectetur adipisicing elit.
												Excepturi quas sapiente voluptate earum natus facilis
												dolor deserunt dolorum tempora obcaecati consequatur
												rem, vel distinctio perferendis tempore nemo sequi eos
												accusantium.
											</p>
										</div>
									</div>
									<Link className="flex justify-center mt-3" to="/">
										<img
											src={GithubIcon}
											style={{ width: "30px", height: "30px" }}
											alt=""
										/>
										<p className="mt-1 ml-2 font-medium">View Code</p>
									</Link>
								</div>
							</Slide>
						</div>
					</div>
				</section>
			</Zoom>
		</>
	);
}
